import * as React from 'react'
//import { Label as KendoLabel , Input as KendoInput } from '@progress/kendo-react-all';

// use DOM controls

const Ch = (children: React.ReactChildren) => children || <></>;

export const Input = (props: any) => <input {...props}  />;
export const Label = (props: any) => <label {...props} >{Ch(props.children) }</label>;
export const Select = (props: any) => <select {...props}>{props.children || <></>}</select>;
export const Div = (props: any) => <div {...props}>{props.children || <></>}</div>;
export const Button = (props: any) => <button {...props}>{props.children || <></>}</button>;
 
// Kendo
//export const Input = (props: any) => <KendoInput {...props} />;
//export const Label = (props: any) => <KendoLabel {...props} >{props.children}</KendoLabel>;
